/* eslint-env node */
import json from './data.json';

export default {
  getNews(searchTerm) {
    if(process.env.NODE_ENV === 'production') {
      return Promise.resolve(json);
    }
    const APIKEY = process.env.VUE_APP_APIKEY;
    return fetch(`https://newsapi.org/v2/top-headlines?country=us&apiKey=${APIKEY}&q=${encodeURIComponent(searchTerm)}&pageSize=35`)
      .then(response => {
        if(!response.ok) {
          throw new Error(response.statusText || 'Error! Response not okay ');
        }
        return response.json();
      });
  }
};